<template>
  <header class="page-container tablet:mb-8">
    <div class="tablet:flex justify-between mb-4 gap-8">
      <div class=" basis-1/3 shrink-0 mb-6">
        <MDC :value="page.title" class="page-title text-dark text-left mb-6" tag="h1" unwrap="p"/>
        <ButtonCta
                v-if="page?.meta.cta"
                :cta="page.meta.cta"
                class="btn-brand"/>
      </div>
      <ContentRenderer
              :class="{'hidden tablet:block': !showBodyMobile}"
              :value="page"
              class="with-free-text text-grey pt-1"
      />
    </div>
    <picture v-if="imgUri" class="bg-light block rounded-img">
      <media-source
              :dimensions="heroDimensions"
              :sizes="heroSizes"
              :uri="imgUri"
              as="source"
              format="webp"
      />
      <media-source
              :alt="page.title"
              :dimensions="heroDimensions"
              :sizes="heroSizes"
              :uri="imgUri"
              as="img"
              class-name="w-full h-full object-cover object-center rounded-img aspect:square tablet:aspect-1240/440"
              format="jpg"
      />
    </picture>
  </header>
</template>
<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";

const {page, showBodyMobile = false} = defineProps<{
    page: PageCollectionItemBase,
    showBodyMobile?: boolean
}>();
const imgUri = computed<string>(() => (page.meta?.imageRef as string || '').replace('/assets', ''));
const heroDimensions = [
    {width: 3840},
    {width: 2560},
    {width: 1920},
    {width: 1280},
    {width: 640}
];
const heroSizes = '100vw';
</script>